import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSmartModalService } from "ngx-smart-modal";
import { Athlete } from "../models/athlete";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "../models/user";
import { UserService } from "../services/user/user.service";
import { CategoryService } from "../services/category/category.service";
import { Company } from "../models/company";
import { Service } from "../models/service";
import { ServiceService } from "../services/service/service.service";
import { RegisterCompanyComponent } from "./register-company/register-company.component";


@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

    @ViewChild(RegisterCompanyComponent) companyOnboarding?: RegisterCompanyComponent;

    stepNumber: number = 1;
    steps: any[] = [];
    stepsAthlete: any[] = [
        { id: 1, title: 'Tipologia di account', text: "Seleziona una tipologia di account" },
        { id: 2, title: 'Info utente', text: "Inserisci le informazioni riferite" },
        { id: 3, title: 'Info atleta/i', text: "Inserisci le informazioni riferite all'atleta" },
        { id: 4, title: 'Condizioni del servizio', text: "Accettazione dei termini e condizioni del servizio." },
        { id: 5, title: 'Invio registrazione', text: "" },
    ];
    stepsAgent: any[] = [
        { id: 1, title: 'Tipologia agente', text: "" },
        { id: 2, title: 'Informazioni personali', text: "" },
        { id: 3, title: 'Informazioni aziendali', text: "" },
        { id: 4, title: 'Indirizzo e contatti', text: "" },
        { id: 5, title: 'Modalità di pagamento', text: "" },
        { id: 6, title: 'Documenti', text: "" },
        { id: 7, title: 'Credenziali di accesso', text: "" },
        { id: 8, title: 'Termini e condizioni', text: "" },
        { id: 9, title: 'Verifica OTP', text: "" },
        { id: 10, title: 'Congratulazioni', text: "" },
    ];
    stepsCompany: any[] = [
        { id: 1, title: 'Account manager', text: "" },
        { id: 2, title: 'Dati rappresentante', text: "" },
        { id: 3, title: 'Contatti rappresentante', text: "" },
        { id: 4, title: 'Informazioni societarie', text: "" },
        { id: 5, title: 'Seleziona servizi', text: "" },
        { id: 6, title: 'Termini e condizioni', text: "" },
        { id: 7, title: 'Verifica OTP/Token', text: "" },
        { id: 8, title: 'Metodo di pagamento', text: "" },
        { id: 9, title: 'Congratulazioni', text: "" },
    ];

    stepsStaff = [
        { id: 1, title: 'Benvenuto', text: '' },
        { id: 2, title: 'Ruolo', text: '' },
        { id: 3, title: 'Dati personali', text: '' },
        { id: 4, title: 'Documenti', text: '' },
        { id: 5, title: 'Credenziali', text: '' },
        { id: 6, title: 'Termini e condizioni', text: '' },
        { id: 7, title: 'Verifica OTP', text: '' },
        { id: 8, title: 'Congratulazioni', text: '' }
    ];

    typeOfRegistration: string = 'athlete';
    typesOfAccount: string[] = ['userAthlete', 'userParent', 'agentCommerce', 'agentFreelance', 'agentPrivate'];
    typeOfAccount: string = this.typesOfAccount[1];

    newUser: User = new User();
    listOfAthletes: Athlete[] = [];
    newAthlete: Athlete = new Athlete();
    allAthletesAreValid: boolean = false;
    newCompany: Company = new Company();

    isEditingAthlete: boolean = false;
    athleteIndex: number = -1;

    services: Service[] = [];
    idServiceFromQuery: string | null = null;
    manualOnboarding: boolean = false;

    constructor(
        public ngxSmartModalService: NgxSmartModalService,
        public userService: UserService,
        public categoryService: CategoryService,
        public serviceService: ServiceService,
        public router: Router,
        public route: ActivatedRoute) {
    }

    async ngOnInit(): Promise<void> {
        console.log('paramMap ', this.route.snapshot)

        if (this.route.snapshot.data['typeOfRegistration']) {
            this.typeOfRegistration = this.route.snapshot.data['typeOfRegistration'] ?? 'athlete';
        } else {
            this.typeOfRegistration = this.route.snapshot.paramMap.get('typeOfRegistration') ?? 'athlete';
        }

        this.newUser.subtype = this.typeOfAccount;
        this.idServiceFromQuery = this.route.snapshot.queryParamMap.get('idService') ?? this.route.snapshot.queryParamMap.get('idservice');
        this.services = await this.serviceService.getAllServices();
        this.manualOnboarding = !!this.route.snapshot.data['manualOnboarding'];

        if (this.typeOfRegistration === 'athlete') {
            this.steps = this.manualOnboarding
                ? this.stepsAthlete.filter(step => step.id !== 5)
                : [...this.stepsAthlete];
        } else if (this.typeOfRegistration === 'agent') {
            this.steps = [...this.stepsAgent];
            this.newUser.subtype = this.typesOfAccount[2];  // per impostare il valore di default nel dropdown "tipologia di agente"
        }
        else if (this.typeOfRegistration === 'company') this.steps = [...this.stepsCompany];
        else if (this.typeOfRegistration === 'staff') this.steps = [...this.stepsStaff];
    }

    async logoutOnboarding(): Promise<void> {
        try {
            await this.companyOnboarding?.saveBeforeExit();
        } finally {
            sessionStorage.removeItem('register-company-password');
            this.userService.logout();
        }
    }

    setTypeOfAccount(type: string) {
        this.typeOfAccount = type;
        this.newUser.subtype = type;
    }

    nextStep() {
        console.log('nextStep')
        if (this.stepCheck()) {
            if (this.typeOfAccount === this.typesOfAccount[0] || this.typeOfAccount === this.typesOfAccount[0]) {
                if (this.stepNumber === 1) {
                    this.listOfAthletes = [];
                }
                if (this.stepNumber === 2) {
                    if (this.typeOfAccount === this.typesOfAccount[0]) {
                        this.newAthlete = new Athlete();
                        this.newAthlete.firstName = this.newUser.firstName;
                        this.newAthlete.lastName = this.newUser.lastName;
                        this.listOfAthletes = [this.newAthlete];
                    }

                }
                if (this.stepNumber === 3) {
                    this.newUser.athletes = [...this.listOfAthletes];
                    // this.allAthletesAreValid = this.checkAthletesAreValid();
                }
            }

            this.stepNumber++;
        }
    }

    previousStep() {
        if (this.stepNumber === 1) {
            this.listOfAthletes = [];
            this.stepNumber = 1;
        }

        this.stepNumber--;
    }

    stepCheck() {
        // sto creando un account per il genitore/tutore
        if (this.typeOfAccount === this.typesOfAccount[1]) {
            if (this.stepNumber === 2) {
                return (
                    this.newUser.firstName.trim() !== '' &&
                    this.newUser.lastName.trim() !== '' &&
                    this.newUser.email.trim() !== '' &&
                    this.newUser.phone?.trim() !== '' &&
                    this.newUser.password!.trim() !== ''
                )
            }
        }
        return true;
    }

    openModal() {
        if (!this.isEditingAthlete) {
            this.newAthlete = new Athlete();
        }
        this.ngxSmartModalService.getModal('addAthlete').open();
    }

    closeModal() {
        this.allAthletesAreValid = this.checkAthletesAreValid();
        this.ngxSmartModalService.getModal('addAthlete').close();
    }

    addAthleteToList(athlete: Athlete) {
        if (this.athleteIsValid(athlete)) {
            this.closeModal();
            if (this.isEditingAthlete) {
                this.listOfAthletes[this.athleteIndex] = this.newAthlete;
                if (this.typeOfAccount === this.typesOfAccount[1]) this.newAthlete = new Athlete();
                this.isEditingAthlete = false;
            } else {
                this.listOfAthletes.push(this.newAthlete);
            }

        }
    }

    editAthlete(i: number) {
        this.newAthlete = this.listOfAthletes[i];
        this.isEditingAthlete = true;
        this.athleteIndex = i;
        this.openModal();
    }

    athleteIsValid(athlete: Athlete) {
        return athlete.firstName !== '' &&
            athlete.lastName !== '' &&
            athlete.bornDate !== '' &&
            athlete.bornCity !== '' &&
            athlete.fiscalCode !== '' &&
            athlete.categoryId !== '' &&
            athlete.alreadyPlayedInCompany;
    }

    companyLegalIsValid() {
        return (
            this.newCompany.legalFirstName &&
            this.newCompany.legalLastName &&
            this.newCompany.legalAddress &&
            this.newCompany.legalZip &&
            this.newCompany.legalProvince &&
            this.newCompany.legalCity &&
            this.newCompany.legalFiscalCode &&
            this.newCompany.legalDocumentNumber &&
            this.newCompany.legalEmail &&
            this.newCompany.legalPhone
        )
    }

    checkAthletesAreValid() {
        return this.listOfAthletes.every(athlete => this.athleteIsValid(athlete));
    }

    /*    deleteAthlete(i: number) {
            Swal.fire({
                title: `Sei sicuro di voler rimuovere ${this.listOfAthletes[i].firstName} ${this.listOfAthletes[i].lastName}?`,
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, rimuovi'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.listOfAthletes.splice(i, 1);
                    Swal.fire(
                        'Rimosso!',
                        'Atleta rimosso',
                        'success'
                    )
                }
            })
        }
    
        backToLogin() {
            this.router.navigate(['/login'])
        }
    
        sendRegistrationUser() {
            this.userService.register(this.newUser)
                .then(res => console.log('response: ', res))
        }
    
        sendRegistrationCompany(){
            this.companyService.register(this.newCompany);
        }
    
        generateServiceDescription(service: Service) {
            if (service.priceType === 'monthly') {
                return `(${parseInt(service.price)} a canone mensile + 2% a transazione)`
            }
            else {
                return `(${parseInt(service.price)} a canone mensile + 2% a transazione)`
            }
        }
    
        selectService(service: Service){
            if (this.servicesSelected.find( (elem: Service) => service.id === elem.id) ){
                this.servicesSelected = [...this.servicesSelected.filter( (item: Service) => service.id !== item.id)];
            } else {
                this.servicesSelected.push(service)
            }
        }*/

    updateStep($event: any) {
        this.stepNumber = $event;
    }

    updateSteps($event: any) {
        if (this.typeOfRegistration === 'agent' || this.typeOfRegistration === 'company' || this.typeOfRegistration === 'staff') {
            this.steps = $event;
        }
    }

}
